import React, { useState, useEffect, useContext } from 'react';
import { Button, Modal, Box, Typography, Card, IconButton, CardActions } from '@mui/material';
import axios from 'axios';
import { UserContext } from '../UserContext';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import { toast, ToastContainer } from 'react-toastify';
import AddIcon from '@mui/icons-material/Add';
import LabeledTextField from './LabeledTextField';
import './AddProduct.css';
import DrawerComponent from './common/DrawerComponent';

const AddService = () => {
  const [open, setOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sidebars, setSidebars] = useState([]);
  const [roleId, setRoleId] = useState(null)
  const [product, setProduct] = useState({
    id: null,
    service_name: '',
    service_type: '',
    service_description: '',
    img: '',
    color: '',
  });
  const [productToDelete, setProductToDelete] = useState(null);
  const { user_id, role } = useContext(UserContext);
  const [currentDate, setCurrentDate] = useState(getFormattedDate());

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get('api/services/');
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setProduct({
      id: null,
      service_name: '',
      service_type: '',
      service_description: '',
      color: '',
      img: '',
    });
    setOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProduct((prevProduct) => ({
      ...prevProduct,
      [name]: value,
    }));
  };


  useEffect(() => {
    async function fetchRoleId() {
      if (!role) return;
      try {
        const response = await axios.get(
          `/api/get-role-id/`,
          { params: { role_name: role } }
        );
        setRoleId(response.data.role_id);
      } catch (error) {
        console.error("Error fetching role id:", error);
        toast.error("Failed to fetch role id");
      }
    }
    fetchRoleId();
  }, [role]);


  useEffect(() => {
    async function fetchSidebarPermissions() {
      if (!roleId) return;
      setIsLoading(true);
      try {
        const response = await axios.get(
          `/api/sidebars/role/${roleId}/`
        );
        setSidebars(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching sidebar permissions:", error);
        toast.error("Failed to fetch sidebar permissions");
      } finally {
        setIsLoading(false);
      }
    }
    fetchSidebarPermissions();
  }, [roleId]);

  console.log(sidebars, "11111111111");

  const addProductSidebar = sidebars.find(
    (item) => item.action_link === "/AddService"
  );

  const rolePermissions = addProductSidebar?.roles.find(
    (role) => role.role_id === roleId
  )?.permissions;






  const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    // Create a FormData object for both POST and PUT requests
    const formData = new FormData();
    formData.append('service_name', product.service_name);
    formData.append('service_type', product.service_type);
    formData.append('service_description', product.service_description);
    formData.append('color', product.color);

    // Only append the image if it exists and is a file (not a string URL from a previous fetch)
    if (product.img && product.img instanceof File) {
      formData.append('img', product.img);
    }

    if (product.id) {
      await axios.put(`api/services/${product.id}/?updated_by=${user_id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    } else {
      // Create new service (POST request)
      await axios.post(`api/services/?created_by=${user_id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }

    // Refresh product list and close the form
    fetchProducts();
    handleClose();
  } catch (error) {
    console.error('Error saving product:', error);
    toast.error('Error saving service');
  }
};

  const handleEdit = (product) => {
    setProduct(product);
    handleOpen();
  };

  const handleDelete = (id) => {
    setProductToDelete(id);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`api/services/${productToDelete}/?deleted_by=${user_id}`);
      fetchProducts();
    } catch (error) {
      console.error('Error deleting product:', error);
    } finally {
      setProductToDelete(null);
      setConfirmOpen(false);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setProduct((prev) => ({
      ...prev,
      img: file,
    }));
  };

  function getFormattedDate() {
    const now = new Date();
    const day = now.toLocaleString('en-US', { weekday: 'short' });
    const month = now.toLocaleString('en-US', { month: 'short' });
    const date = now.toLocaleString('en-US', { day: '2-digit' });
    const year = now.getFullYear();
    const time = now.toLocaleString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
    return `${day}, ${month} ${date}, ${year} ${time}`;
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDate(getFormattedDate());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <Box className="page-container">
      <ToastContainer />
      <div className="header-container">
        <Box className="header-icon-container">
          <MiscellaneousServicesIcon style={{ color: '#fb7102', fontSize: '28px' }} />
          <span className="Title">Services</span>
        </Box>
        <span className="date-display">{currentDate}</span>
      </div>

      <Box className="content-container">
        <Box className="right-column">
          <Box className="button-container">

            <button className="button_style" onClick={() => {
              if (rolePermissions?.is_add) {
                handleOpen();
              } else {
                toast.error("You don't have permission to add server.");
              }
            }}>
              <AddIcon style={{ verticalAlign: 'middle', marginRight: 6, fontSize: 25 }} />
              Add Service
            </button>

          </Box>

          <Box className="card-grid">
            {products.map((prod) => (
              <Card
                key={prod.id}
                className="card"
                style={{ background: prod.color || '#f5f5f5' }}
              >
                <img
                  src={
                    prod.img.startsWith('/media')
                      ? `${process.env.REACT_APP_BACKEND_URL || 'api'}${prod.img}`
                      : prod.img
                  }
                  alt={prod.service_name}
                />
                <p className="service_name">{prod.service_name}</p>

                <CardActions className="card-actions">
                  <IconButton aria-label="edit" size="small"
                    onClick={() => {
                      if (rolePermissions?.is_update) {
                        handleEdit(prod);
                      } else {
                        toast.error("You don't have permission to Edit server.");
                      }
                    }}
                  >
                    <EditIcon fontSize="small" style={{ color: '#5569a6' }} />
                  </IconButton>
                  <IconButton
                    aria-label="delete"
                    size="small"
                    onClick={() => {
                      if (rolePermissions?.is_delete) {
                        handleDelete(prod.id);
                      } else {
                        toast.error("You don't have permission to Delete server.");
                      }
                    }}
                  >
                    <DeleteIcon fontSize="small" style={{ color: '#C53B31' }} />
                  </IconButton>
                </CardActions>

              </Card>
            ))}
          </Box>
        </Box>
      </Box>

      <DrawerComponent
        open={open}
        onClose={handleClose}
        title={product.id ? 'Edit Service' : 'Add New Service'}
      >
        <form onSubmit={handleSubmit} className="drawer-form">
          <label htmlFor="custom-file-input">
            <Typography variant="subtitle1" className="file-upload-label">
              Choose File
              <input
                id="custom-file-input"
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={handleFileChange}
                style={{ display: 'none' }}
              />
              <Box className="file-upload-container">
                <img src="upload_file.png" alt="Upload" />
                <Typography variant="body2">
                  {product.img ? `Selected file: ${product.img.name}` : 'No file chosen'}
                </Typography>
              </Box>
            </Typography>
          </label>
          <LabeledTextField
            fullWidth
            label="Service Name"
            variant="outlined"
            margin="normal"
            name="service_name"
            value={product.service_name}
            onChange={handleChange}
            required
          />
          <LabeledTextField
            fullWidth
            label="Service Type"
            variant="outlined"
            margin="normal"
            name="service_type"
            value={product.service_type}
            onChange={handleChange}
            required
          />
          <LabeledTextField
            fullWidth
            label="Service Description"
            variant="outlined"
            margin="normal"
            name="service_description"
            value={product.service_description}
            onChange={handleChange}
            required
          />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Typography component="label" htmlFor="color-picker" className="color-picker-label">
              Pick a light Color
            </Typography>
            <input
              id="color-picker"
              type="color"
              name="color"
              value={product.color}
              onChange={(e) => setProduct((prev) => ({ ...prev, color: e.target.value }))}
              className="color-picker"
              required
            />
          </Box>
          <Button type="submit" variant="contained" className="submit-button">
            {product.id ? 'Update' : 'Submit'}
          </Button>
        </form>
      </DrawerComponent>

      <Modal open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <Box className="confirm-modal">
          <Typography variant="h6" component="h2">
            Are you sure you want to delete this service? If yes, all related enquiries will also be
            deleted automatically.
          </Typography>
          <Box className="modal-actions">
            <Button variant="contained" onClick={confirmDelete} className="modal-button">
              Yes
            </Button>
            <Button
              variant="contained"
              onClick={() => setConfirmOpen(false)}
              className="modal-button"
            >
              No
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default AddService;